import { OrgUnit, UpdateOrgUnit } from '@/types/core/OrgUnit';

/**
 * A complete UpdateOrgUnit payload built from a loaded OrgUnit, with `overrides` applied last.
 *
 * The backend maps UpdateOrgUnitDto onto the entity with AutoMapper `MemberList.None` and no
 * null-condition — it is a total overwrite, so any field left out of the payload is written back
 * as NULL. Every partial update (a move changes only `parentId`; the details form only touches
 * what it renders) must therefore go through here rather than posting the changed fields alone.
 */
export function buildOrgUnitUpdatePayload(
  orgUnit: OrgUnit,
  overrides: Partial<UpdateOrgUnit> = {},
): UpdateOrgUnit {
  return {
    type: orgUnit.type,
    code: orgUnit.code,
    name: orgUnit.name,
    isActive: orgUnit.isActive,
    parentId: orgUnit.parentId,
    sortOrder: orgUnit.sortOrder,
    timezone: orgUnit.timezone,
    country: orgUnit.country,
    metadata: orgUnit.metadata,
    defaultDimensionSetId: orgUnit.defaultDimensionSetId,
    ownerPrincipalType: orgUnit.ownerPrincipalType,
    ownerPrincipalId: orgUnit.ownerPrincipalId,
    ownerPrincipalQualifier: orgUnit.ownerPrincipalQualifier,
    ...overrides,
  };
}
